import { render, staticRenderFns } from "./TipForPersonalData.vue?vue&type=template&id=186d8f2e&"
import script from "./TipForPersonalData.vue?vue&type=script&lang=js&"
export * from "./TipForPersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports